import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-primary mb-0" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "navbar-brand company-name" }
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarNavAltMarkup"
}
const _hoisted_5 = {
  id: "aboutId",
  class: "navbar-nav fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.companyIconFileName,
        class: "d-inline-block align-text-bottom",
        "border-color": "red",
        width: "65",
        height: "65"
      }, null, 8, _hoisted_2),
      _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.companyName), 1),
      _cache[9] || (_cache[9] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-toggle": "collapse",
        "data-target": "#navbarNavAltMarkup"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/login",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Login", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/schedule",
            name: "schedule",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Schedule", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/jobcalls",
            name: "jobcalls",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Jobcalls", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/profile",
            name: "profile",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Profile", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/documents",
            name: "documents",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Documents", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/changepassword",
            name: "changepassword",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Change Password ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/logout",
            name: "logout",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Logout", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/register",
            name: "register",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" Register3 ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    }))
  ], 64))
}